var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 36,
    rx: 6,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_151)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3101 18C12.3101 17.3505 12.4179 16.7277 12.6106 16.1436L9.24025 13.57C8.58338 14.9036 8.21338 16.4064 8.21338 18C8.21338 19.5923 8.58307 21.0941 9.23885 22.4269L12.6073 19.8483C12.4165 19.2669 12.3101 18.6464 12.3101 18Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2277 12.0909C19.6388 12.0909 20.9133 12.5909 21.9147 13.4091L24.8279 10.5C23.0527 8.95453 20.7768 8 18.2277 8C14.2702 8 10.869 10.2631 9.24036 13.57L12.6105 16.1436C13.3871 13.7864 15.6007 12.0909 18.2277 12.0909Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2277 23.9091C15.6008 23.9091 13.3872 22.2136 12.6107 19.8564L9.24036 22.4295C10.869 25.7369 14.2702 28 18.2277 28C20.6702 28 23.0022 27.1327 24.7524 25.5077L21.5533 23.0345C20.6507 23.6031 19.514 23.9091 18.2277 23.9091Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7866 18C27.7866 17.4091 27.6955 16.7727 27.5589 16.1819H18.2277V20.0455H23.5989C23.3303 21.3628 22.5994 22.3755 21.5533 23.0345L24.7523 25.5077C26.5908 23.8014 27.7866 21.2595 27.7866 18Z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.c316bf08a559a814a81ea73ea72f4c5d.svg";
export { ForwardRef as ReactComponent };